import { Component, ViewEncapsulation, OnInit } from "@angular/core";
import { DefaultStateService } from '@formbird/services';

@Component({
  selector: 'ft-not-secure',
  templateUrl: './not-secure.component.html',
  styleUrls: ['./not-secure.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class NotSecureComponent implements OnInit {
  constructor(
    private defaultStateService: DefaultStateService
  ) {
  }
  changeState() {
    this.defaultStateService.changeToDefaultState();
  }

  ngOnInit() {
  }
}
